import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import * as React from 'react';
import classNames from './cookiesBanner.classNames';

export const CookiesBanner = () => {
  const [hidden, toggleHidden] = React.useState(false);
  const toggleHiddenFunction = () => {
    toggleHidden(!hidden);
  };

  return (
    <div className={classNames().root} hidden={hidden}>
      <div>
        <div className={`cookie-inform ${classNames().cookiesBanner}`}>
          <div className={classNames().textSection}>
            <p>This site uses cookies for analytics, personalized content and ads.</p>
            <p>By continuing to browse this site, you agree to this use. <a href='//go.microsoft.com/fwlink/?linkid=845480' target='_blank' rel='noopener noreferrer'>Learn more.</a></p>
          </div>
            <PrimaryButton onClick={toggleHiddenFunction}>
              Got it
            </PrimaryButton>
        </div>
      </div>
    </div>
  );
};
